import { render, staticRenderFns } from "./PaidTierProjectSections.vue?vue&type=template&id=fcb0672e&scoped=true&"
import script from "./PaidTierProjectSections.vue?vue&type=script&lang=js&"
export * from "./PaidTierProjectSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb0672e",
  null
  
)

export default component.exports